var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('unordered-list',_vm._l((_vm.links),function(item,index){return _c('list-item',{key:index},[_c('image-link',{attrs:{"link":item.link,"src":_vm.imagePath(item.fileName),"alt":item.alt,"self-window":item.selfWindow}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }